export const cleanBrTagsAdvanced = (html: string): string => {
	let cleaned = html.replace(/(<br\s*\/?>)+/gi, '<br>');
	cleaned = cleaned.replace(/<br\s*\/?>(?=\s*<[a-zA-Z])/gi, '');
	cleaned = cleaned.replace(/^(<br\s*\/?>)+|(<br\s*\/?>)+$/gi, '');
	return cleaned;
}